"use client";
import "./index.css";
import PageTitle from "@/components/common-components/page-title/PageTitle";
import FaqSection from "@/components/common-components/faqs/FaqSection";
import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Post from '@/components/common-components/post/Post';
import RecentBlog from '@/components/common-components/recent-blog/RecentBlog';
import CustomPagination from '@/components/common-components/CustomPagination';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBlogsData, fetchRecentBlogs, fetchTags } from '@/redux/blogsSlice';
import { formatDate } from '@/utlility/Functions';
import Link from 'next/link';

const BlogPage = () => {
  const [page, setPage] = useState(0);
  const [tagPage, setTagPage] = useState(1);
  const [selectedTags, setSelectedTags] = useState([]);
  const blogsData = useSelector((state) => state.blogs.blogsData);
  const recentBlogs = useSelector((state) => state.blogs.recentBlogs);
  const popularTags = useSelector((state) => state.blogs.tags);
  const dispatch = useDispatch();
  const limit = 4;

  const handleTagClick = (tagId) => {
    setSelectedTags((prevTags) =>
      prevTags.includes(tagId)
        ? prevTags.filter((id) => id !== tagId)
        : [...prevTags, tagId]
    );
    setPage(0);
  };

  const status = useSelector((state) => state.blogs.status);
  const recentStatus = useSelector((state) => state.blogs.recentStatus);

  useEffect(() => {
    if (recentStatus === 'idle') {
      const payload = {
        organization_key: process.env.NEXT_PUBLIC_ORGANIZATION_KEY,
        page: 1,
        limit: 3,
      };
      dispatch(fetchRecentBlogs({ payload }));
    }
  }, [dispatch, recentStatus]);

  useEffect(() => {
    // Fetch data on mount and whenever page or tags change
    const payload = {
      organization_key: process.env.NEXT_PUBLIC_ORGANIZATION_KEY,
      page: page + 1,
      limit: limit,
    };

    if (selectedTags.length > 0) {
      payload.tag_ids = selectedTags;
    }

    dispatch(fetchBlogsData({ payload }));
  }, [dispatch, page, selectedTags]);

  useEffect(() => {
    // Only fetch tags if not already loaded OR if we are on a new page (tagPage > 1)
    if (tagPage === 1 && popularTags?.data?.data?.length > 0) return;

    const tagsPayload = {
      organization_key: process.env.NEXT_PUBLIC_ORGANIZATION_KEY,
      page: tagPage,
      limit: 25,
    };
    dispatch(fetchTags(tagsPayload));
  }, [dispatch, tagPage]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <>
      <PageTitle
        image="/images/blog-bg.webp"
        name="Blog"
        link={"/blog"}
      />
      <section className="blog-page-main">
        <Container>
          <div className="grid blog-page-cover">
            <div className="g-col-12 g-col-lg-12 g-col-xl-8" >
              <div className="grid blog-post-cover">
                {blogsData?.data?.map((item, i) => (
                  <div className="g-col-12 g-col-sm-6" key={i}>
                    <Post
                      image={item.blog_image}
                      auther={item.author}
                      date={formatDate(item.created_at, "MMMM DD, YYYY")}
                      title={item.blog_title}
                      link={item.blog_slug}
                      btnTitle=""
                    />
                  </div>
                ))}
              </div>
              {blogsData?.total_records > limit && (
                <CustomPagination
                  currentPage={page}
                  totalRecords={blogsData?.total_records}
                  limit={limit}
                  onPageChange={handlePageChange}
                />
              )}
            </div>
            <div className="g-col-12 g-col-lg-12 g-col-xl-4 ms-xl-auto sidebar-cover">
              <div className="blog-page w-100 d-flex flex-column ms-xl-auto">
                <div className="recent-blog-section">
                  <h3 className="text-capitalize section-title fw-medium">
                    recent post
                  </h3>
                  <div className="grid section-cover w-100">
                    {(Array.isArray(recentBlogs?.data) ? recentBlogs.data : []).map((item, i) => (
                      <div className="g-col-12 g-col-md-6 g-col-lg-4 g-col-xl-12 recent-blog-cover" key={i} >
                        <RecentBlog
                          name={item.author}
                          date={formatDate(item.created_at, "DD-MM-YYYY")}
                          title={item.blog_title}
                          image={item.blog_image}
                          slug={item.blog_slug}
                        />
                      </div>
                    ))}
                  </div>
                </div>
                <div className="filter-tag-section">
                  <h3 className="text-capitalize section-title fw-medium">
                    tags
                  </h3>
                  <div className="d-flex gap-2 flex-wrap">
                    {popularTags?.data?.data?.map((item, i) => {
                      const isActive = selectedTags?.includes(item.id);
                      return (
                        <Link
                          key={i}
                          href="/blog"
                          onClick={(e) => {
                            e.preventDefault();
                            handleTagClick(item.id);
                          }}
                          className={`text-capitalize filter-btn ${isActive ? "tag-active" : ""}`}
                        >
                          {item.name}
                        </Link>
                      );
                    })}
                  </div>
                  {popularTags?.data?.total_records > popularTags?.data?.data?.length && (
                    <button
                      className="view-more-tags text-capitalize"
                      onClick={() => setTagPage((prev) => prev + 1)}
                    >
                      view more
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
      <FaqSection />
    </>
  );
};

export default BlogPage;
